import React from 'react';

const SubtitlesComponent = ({markers, boName}) => {
    const processReasons = (type, reasonField) => {

        return [...markers]
            .filter(([, marker]) => marker.type === type)
            .flatMap(([, marker]) => {
                const reasonData = marker.description[reasonField];
                return Array.isArray(reasonData) ? reasonData.map(reason => reason.name || reason) : [reasonData || "N\u00E3o informado"];
            })
            .reduce((acc, reason) => {
                acc[reason] = (acc[reason] || 0) + 1;
                return acc;
            }, {});
    }

    const countMarkers = (type, label) => {
        const total = [...markers].filter(([, marker]) => marker.type === type).length;
        return total ? {[label]: total} : {};
    }

    const sections = [
        {title: "Ocorrências (Sentry)", label: "Natureza", counts: processReasons("sentry-occurrence", "occ_reasons")},
        {title: "Atendimentos", label: "Natureza", counts: processReasons("dispatch-attendance", "nature")},
        {title: boName, label: "Natureza", counts: processReasons("dispatch-bogcm", "naturesArr")},
        {title: "Despachos", label: "Natureza", counts: processReasons("dispatch-dispatches", "nature")},
        {title: "SOS Cidadão", label: "Item", counts: countMarkers("sos", "SOS Cidadão")},
        {title: "Abordagens", label: "Item", counts: countMarkers("encounter", "Abordagens")},
    ];

    return (
        <div className={"space-y-3"}>
            {
                sections.filter(section => Object.keys(section.counts).length).map((section, i) =>
                    <div key={i}>
                        <h3 className={"mt-0! mb-1! text-[14px]!"}>{section.title}</h3>
                        <table className="w-[95%]">
                            <tbody>
                            <tr>
                                <td className="w-53.25 text-[12px]!"><strong>{section.label}</strong></td>
                                <td className="w-53.25 text-[12px]!"><strong>Total</strong></td>
                            </tr>
                            {Object.keys(section.counts).map((key, i_) =>
                                <tr key={i_} className="border-b border-[#dcdcdc]">
                                    <td className="w-53.25 text-[12px]! py-0.5">{key}</td>
                                    <td className="w-53.25 text-[12px]! py-0.5">{section.counts[key]}</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                )
            }
        </div>
    );
};

export default SubtitlesComponent;